module.exports = __webpack_public_path__ + "img/eicon3-2.5e0f64ac.png";